import { useSimpleReducer } from "common/hooks/useSimpleReducer";
import React, { PropsWithChildren, createContext } from "react";
import { ElementType } from "types/Character/type";

type DraftState = {
  element: ElementType | null;
  rarity: number | null;
  player: ("Player 1" | "Player 2") | null;
  displayMode: "Constellation" | "Point";
  search: string;
  sortConstelDesc: boolean;
  linesWithValues: boolean;
};

type FilterContextType = DraftState & {
  dispatch: (action: Partial<DraftState>) => void;
};

export const defaultValues: FilterContextType = {
  element: null,
  rarity: null,
  player: null,
  displayMode: "Constellation",
  sortConstelDesc: false,
  linesWithValues: true,
  search: "",
  dispatch: () => {},
};
export const FilterContext = createContext<FilterContextType>(defaultValues);

export const FilterProvider = (
  props: PropsWithChildren<Partial<FilterContextType>>
) => {
  const [state, dispatch] = useSimpleReducer<FilterContextType>({
    ...defaultValues,
    ...props,
  });

  return (
    <FilterContext.Provider value={{ ...state, dispatch }}>
      {props.children}
    </FilterContext.Provider>
  );
};
